import { memo } from 'react'

import styled from 'styled-components'

import { Button, ButtonFace, ButtonSize } from '../Button'
import { ActivityAuditOptions } from './ActivityAuditOptions'

export type ActivityAuditPaginationProps = {
  onPageSizeChange: (size: number) => void
  onNextPage: () => void
  size?: number | null
  buttonSize?: ButtonSize
  disabled?: boolean
  withPageSize?: boolean
  sizeOptions?: string[]
  hasNextPage: boolean
}

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 16px 0;
  padding: 0 30px;
  width: 100%;
`

export const ActivityAuditPagination = memo((props: ActivityAuditPaginationProps) => {
  const {
    size,
    onPageSizeChange,
    onNextPage,
    buttonSize = ButtonSize.SMALL,
    disabled = false,
    withPageSize = false,
    sizeOptions,
    hasNextPage
  } = props

  return (
    <Content>
      {hasNextPage && (
        <Button onClick={onNextPage} face={ButtonFace.SECONDARY} size={buttonSize}>
          Show more
        </Button>
      )}
      {withPageSize && (
        <ActivityAuditOptions
          disabled={disabled}
          changeSize={onPageSizeChange}
          size={size || 0}
          sizeOptions={sizeOptions}
        />
      )}
    </Content>
  )
})
